/*=========================================================================================
  File Name: state.js
  Namespace: courses
  Description: Vuex Store - Course state
==========================================================================================*/
import { CUSTOM_CONTENT_AUDIENCE_TYPES } from '@/constants/customContent'

const COURSE_POSSIBLE_STATUS = {
  DRAFT: "draft",
  COMMING_SOON: "coming soon",
  PUBLISHED: "published",
  ARCHIVED: "archived",
  UNPUBLISHED: "unpublished"
}

export const COURSE_POSSIBLE_DIFFICULTY = {
  INFORMATIVE: "informative",
  NOVICE: "novice",
  PROFESSIONAL: "professional",
  ADVANCED: "advanced",
  EXPERT: "expert"
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

export const buildCourseState = () => {
  return {
    id: null,
    name: '',
    slug: '',
    url: '',
    description: '',
    content: [],
    instructors: [],
    difficulty: null,
    learning_areas: [],
    categories: [],
    vendor: null,
    tags: [],
    files: [],
    files_uuids: [],
    status: COURSE_POSSIBLE_STATUS.DRAFT,
    trailer_jwplayer_id: '',
    short_description: '',
    auto_publish_at: null,
    published_date: null,
    created: null, // date of creation
    modified: null, // last modification date
    structureFiles: [],
    bg_image_url: '',
    duration_in_seconds: 0,
    images: {
      main_image_url: ''
    },
    is_featured: false,
    has_cc: false,
    access: {
      related_passes: [],
      user_passes: [],
      has_access: null
    },
    direct_passes: [],
    under_construction: false,
    avg_rating: 0,
    bootcamp_origin: null,
    audience_type: CUSTOM_CONTENT_AUDIENCE_TYPES.PUBLIC,
    business_account_ids: [],
  }
}
const state = {
  currentCourse: buildCourseState(),
  courseList: null,
  results: [],
  next: null,
  previous: null,
  count: 0,
  COURSE_POSSIBLE_STATUS: COURSE_POSSIBLE_STATUS,
  COURSE_POSSIBLE_DIFFICULTY: COURSE_POSSIBLE_DIFFICULTY,
  courseStatusTransitions: {
    [COURSE_POSSIBLE_STATUS.DRAFT]: [COURSE_POSSIBLE_STATUS.DRAFT, COURSE_POSSIBLE_STATUS.COMMING_SOON, COURSE_POSSIBLE_STATUS.PUBLISHED],
    [COURSE_POSSIBLE_STATUS.COMMING_SOON]: [COURSE_POSSIBLE_STATUS.COMMING_SOON, COURSE_POSSIBLE_STATUS.DRAFT, COURSE_POSSIBLE_STATUS.PUBLISHED],
    [COURSE_POSSIBLE_STATUS.PUBLISHED]: [COURSE_POSSIBLE_STATUS.PUBLISHED, COURSE_POSSIBLE_STATUS.ARCHIVED, COURSE_POSSIBLE_STATUS.UNPUBLISHED],
    [COURSE_POSSIBLE_STATUS.ARCHIVED]: [COURSE_POSSIBLE_STATUS.ARCHIVED, COURSE_POSSIBLE_STATUS.PUBLISHED, COURSE_POSSIBLE_STATUS.UNPUBLISHED],
    [COURSE_POSSIBLE_STATUS.UNPUBLISHED]: [COURSE_POSSIBLE_STATUS.UNPUBLISHED, COURSE_POSSIBLE_STATUS.PUBLISHED]
  },
  hundredCourses: null,
  currentCourseFiles: [],
}

export default state
